<template>
  <div class="mstabsdetails row m-0 global__scrollbar">
    <div class="mstabsdetails__tab">
      <div>
        <div v-for="(item, i) in iconList" :key="i" :class="`mstabsdetails__tab--icon bc_deepgreen mb-2 ${item.title === tabSelected.title ? 'icon-selected' : ''}`" :id="`msdetail-icon-${i}`" @click="chooseTab(item)">
          <img :src="item.image" alt="">
          <b-tooltip id="tabs_detail" custom-class="global__bc_deepgreen" :target="`msdetail-icon-${i}`"
          :delay="{ show: 400, hide: 50 }" placement="righttop">
            {{ item.title }}
          </b-tooltip>
        </div>
      </div>
    </div>
    <keep-alive>
      <div class="py-4 w-75">
        <div class="mb-4 text-sm text-darkgray font-weight-bold">
            {{ tabSelected.title }}
        </div>
        <div class="w-100">
            <template v-for="(field, i) in tabSelected.fields">
                <b-row class="mb-1" :key="i">
                    <b-col cols="4" class="text-sm text-darkgray">{{ field.label }}</b-col>
                    <b-col cols="8" class="text-sm text-deepgreen font-weight-bold">
                      <template v-if="field.label === 'Route Optimize'">
                        <div class="d-flex align-items-center">
                          : 
                          <input style="accent-color: #285231; margin: 0 4px;" type="checkbox" :checked="detail[field.key] ? true : false" onclick="return false;" />
                          <span class="font-weight-light">
                            Include in route optimize
                          </span>
                        </div>
                      </template>
                      <template v-else-if="field.key === 'created_at'">
                        : {{ convertDate(detail.created_at)}}
                      </template>
                      <template v-else-if="['tms_departure_time', 'tms_eta'].includes(field.key)">
                        : {{ convertDate(detail[field.key]) }}
                      </template>
                      <template v-else>
                      : {{ detail[field.key] || '-' }}
                      </template>
                    </b-col>
                </b-row>
            </template>
        </div>
      </div>
    </keep-alive>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'DetailsLand',
  props: {
    detail: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    const iconList = [
      {
        title: 'Order Details',
        image: require('@/assets/image/icon/msdetail-order-details.svg'),
        fields: [
          { key: 'tms_do_number', label: 'Order No.' },
          { key: 'tms_shipment_number', label: 'Shipment No.' },
          { key: 'tms_batch_no', label: 'Batch No.' },
          { key: 'tms_duplicate_from', label: 'Duplicate From' },
          { key: 'created_at', label: 'Created Date' },
          { key: 'tms_aging_days', label: 'Aging Days' },
          { key: 'tms_departure_time', label: 'Shipment Date' },
          { key: 'tms_eta', label: 'ETA' },
          { key: 'tms_service_time', label: 'Service Time' },
          { key: 'tms_window_start_time', label: 'Window Start Time' },
          { key: 'tms_window_end_time', label: 'Window End Time' },
          { key: 'tms_cod_amount', label: 'COD Amount' },
          { key: 'tms_fleet_category', label: 'Fleet Category' },
          { key: 'tms_fleet_type', label: 'Fleet Type' },
          { key: 'tms_route_optimize', label: 'Route Optimize' }
        ]
      },
      {
        title: 'Origin And Destination',
        image: require('@/assets/image/icon/msdetail-origin.svg'),
        fields: [
          { key: 'city_from', label: 'Origin' },
          { key: 'detail_address_from', label: 'Detail Address (Origin)' },
          { key: 'city_to', label: 'Destination' },
          { key: 'detail_address_to', label: 'Detail Address (Destination)' }
        ]
      },
      {
        title: 'Fleet Assign Information',
        image: require('@/assets/image/icon/shipment-land.svg'),
        fields: [
          { key: 'plate_no', label: 'Plate No.' },
          { key: 'tms_driver_name', label: 'Driver' }
        ]
      },
      {
        title: 'Note',
        image: require('@/assets/image/icon/note-text.svg'),
        fields: [
          { key: 'delivery_order', label: 'Delivery Order' },
          { key: 'customer_special', label: 'Customer Special' },
          { key: 'tms_note', label: 'Note' }
        ]
      }
    ]
    return {
      tabSelected: iconList[0],
      iconList
    }
  },
  methods: {
    chooseTab (item) {
      this.tabSelected = item
    },
    convertDate (date) {
      if (date) {
        return moment(date).format('DD MMMM YYYY')
      }
      return '-'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/requestList/detail/DetailsLand.vue